import { render, staticRenderFns } from "./mfa.vue?vue&type=template&id=43321b95&scoped=true&"
import script from "./mfa.vue?vue&type=script&lang=js&"
export * from "./mfa.vue?vue&type=script&lang=js&"
import style0 from "./mfa.vue?vue&type=style&index=0&id=43321b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43321b95",
  null
  
)

export default component.exports